import React from "react";
import { Button, Typography } from "@mui/material";

const MailChimp = ({ user }) => {
  return (
    <div>
      <Typography variant="body1" sx={{ marginBottom: 2 }}>
        MailChimp integration coming soon...
      </Typography>
      <Button variant="contained" disabled>
        Configure MailChimp
      </Button>
    </div>
  );
};

export default MailChimp;
